module.exports = __webpack_public_path__ + "img/img_8.fe95d268.png";